import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UserService} from '@services/user.service';
import {AuthenticationService} from '@services/authentification.service';

@Component({
    selector: 'app-form',
    templateUrl: './form.component.html',
    styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit {

    profil = '';
    op = '';
    pro_size = '';
    patrimoine_size = '';
    zone = '';
    source = '';
    age = '';
    step = 'step2';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<FormComponent>,
        public userService: UserService,
        public authenticationService: AuthenticationService,
    ) {

    }

    ngOnInit(): void {
        this.step = this.data.step;
    }

    // Choix unique : la sélection passe directement à l'étape suivante
    // (le court délai laisse voir la coche avant la transition)
    choose(field: string, value: string, next: string): void {
        this[field] = value;
        setTimeout(() => {
            this.step = next;
        }, 250);
    }

    onNoClick(): void {
        this.authenticationService.currentUser.user_onboarding.auto = false;
        this.userService.updateOnboarding(this.authenticationService.currentUser);
        this.sendForm();
    }

    onYesClick(): void {
        this.authenticationService.currentUser.user_onboarding.auto = true;
        this.userService.updateOnboarding(this.authenticationService.currentUser);
        this.sendForm();
    }

    sendForm() {
        this.userService.answerForm({
            profil: this.profil,
            op: this.op,
            pro_size: this.pro_size,
            patrimoine_size: this.patrimoine_size,
            zone: this.zone,
            source: this.source,
            age: this.age + '',
        }).subscribe(invoices => {
            this.dialogRef.close(true);
        }, error => {
        });
    }
}
